import './Box.css';
import { AiOutlineUser } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { MdOutlinePlace } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
import {  useSelector } from 'react-redux';

const Box = () => {

  const user = JSON.parse(localStorage.getItem("user"));

  // Fetch data from Redux store
  const dashboardData = useSelector((state) => state.dashboard.data);
  const siteName = user?.empsitename || "Site Name";



  // Define the data for each box (using the Redux state values)
  const data = [
    { title: "Site Name", count: siteName, icon: <MdOutlinePlace size={30} />, color: "#8e44ad", role: ["MANAGER", "CONCIERGE"] , className: "site-name-box"},
    { title: "Total Visitors", count: dashboardData.totalVisitors || 0, icon: <AiOutlineUser size={30} />, color: "#4caf50", role: ["SUPERADMIN","MANAGER", "CONCIERGE"] },
    { title: "Total Concierges", count: dashboardData.totalConcierges || 0, icon: <FiUsers size={30} />, color: "#f44336", role: ["SUPERADMIN","MANAGER"] },
    { title: "Total Sites", count: dashboardData.totalSites || 0, icon: <MdOutlinePlace size={30} />, color: "#2196f3", role: ["SUPERADMIN"] },
    { title: "Total Managers", count: dashboardData.totalManagers || 0, icon: <HiOutlineUserGroup size={30} />, color: "#ff9800", role:["SUPERADMIN"] },
   
  ];

return (
  <div className="row boxrow">
    {data.map((item, index) => (
      item.role.includes(user?.role) && (
        <div className="box" key={index} style={{ borderLeft: `5px solid ${item.color}` }}>
          <div className="box-icon" style={{ color: item.color }}>
            {item.icon}
          </div>
          <div className="box-content">
            <h3>{item.title === "Site Name" ? item.count : item.count}</h3>
            <p>{item.title}</p>
          </div>
        </div>
      )
    ))}
  </div>
);
};

export default Box;
